import { useQuery } from '@/hooks/useQuery'
import { queryKeys } from '@/api/queryKeys'
import { apiClient } from '../client'

export interface EngineerOption {
  userId: string
  userName: string
  role: string
}

export async function getEngineers(keyword?: string): Promise<EngineerOption[]> {
  const search = new URLSearchParams()
  if (keyword) search.set('keyword', keyword)
  const suffix = search.toString()
  return apiClient.get<EngineerOption[]>(`/api/engineers${suffix ? `?${suffix}` : ''}`)
}

export function useEngineers(keyword?: string) {
  return useQuery({
    queryKey: queryKeys.engineers(keyword),
    queryFn: () => getEngineers(keyword),
  })
}
